import styled, { css } from 'styled-components';
import { getAnimation } from './animations';
import { CursorLabelProps, CursorContainerProps, CursorImageProps } from './animatedCursor.types';

export const CursorImage = styled.img<CursorImageProps>(
  ({ animation }) => css`
    object-fit: contain;
    ${getAnimation(animation)};
  `,
);

export const CursorContainer = styled.div<CursorContainerProps>(({ size }) => {
  return css`
    z-index: 1000000;
    position: fixed;
    pointer-events: none;
    width: ${size}px;
    backface-visibility: hidden;
    will-change: transform;
    display: flex;
    justify-content: center;
    transform: rotate(0deg);
    filter: drop-shadow(0, 0, 4px, rgba(11, 11, 12, 0.25));
    cursor: none;
  `;
});

export const CursorLabel = styled.div<CursorLabelProps>(({ size }) => {
  return css`
    align-items: flex-start;
    color: black;
    display: flex;
    justify-content: flex-start;
    left: ${size - 5}px;
    position: absolute;
    top: ${size - 5}px;
    width: 200px;
  `;
});
